// extracted by mini-css-extract-plugin
export default {"subNav":"SettingsSubNav_subNav__J5oEh","tab":"SettingsSubNav_tab__UsJeq","tabActive":"SettingsSubNav_tabActive__pbpxK"};